import moment from 'moment';
import { QueryParams } from '../models/query-params.interface';

export class DateUtils {
  static fromTo(value: string | number): {
    dateFrom: string;
    dateTo: string;
    period: number;
  } {
    if (!isNaN(Number(value))) {
      const daysToBeIncluded =
        value !== 1 && value !== 2 && value !== '1' && value !== '2'
          ? value
          : Number(value) - 1;
      const date1 = moment()
        .subtract(daysToBeIncluded, 'days')
        .format('YYYY-MM-DD');
      const date2 = moment().add(1, 'days').format('YYYY-MM-DD');
      const period = parseInt(String(value), 10);
      return { dateFrom: date1, dateTo: date2, period };
    } else {
      const date = String(value).split('--');
      const date1 = moment(date[0]).format('YYYY-MM-DD');
      const date2 = moment(date[1]).add(1, 'days').format('YYYY-MM-DD');
      const a = moment(date[0]);
      const b = moment(date[1]);
      const period = -a.diff(b, 'days');
      return { dateFrom: date1, dateTo: date2, period };
    }
  }

  /**
   * Same as fromTo but does NOT add 1 day to the end date.
   * Used for chart display where the end date should be today (not tomorrow).
   */
  static chartFromTo(value: string | number): {
    dateFrom: string;
    dateTo: string;
    period: number;
  } {
    if (!isNaN(Number(value))) {
      const daysToBeIncluded =
        value !== 1 && value !== 2 && value !== '1' && value !== '2'
          ? value
          : Number(value) - 1;
      const date1 = moment()
        .subtract(daysToBeIncluded, 'days')
        .format('YYYY-MM-DD');
      const date2 = moment().format('YYYY-MM-DD');
      const period = parseInt(String(value), 10);
      return { dateFrom: date1, dateTo: date2, period };
    } else {
      const date = String(value).split('--');
      const date1 = moment(date[0]).format('YYYY-MM-DD');
      const date2 = moment(date[1]).format('YYYY-MM-DD');
      const a = moment(date[0]);
      const b = moment(date[1]);
      const period = -a.diff(b, 'days');
      return { dateFrom: date1, dateTo: date2, period };
    }
  }

  static getTimePeriod(
    isReaderOrStoryReader: boolean,
    customParams?: { timePeriod?: string },
    queryParams?: QueryParams,
  ): string {
    if (isReaderOrStoryReader) {
      return '90';
    }

    if (customParams?.timePeriod) {
      return customParams.timePeriod;
    }

    if (queryParams?.time) {
      return queryParams.time;
    }

    return '7';
  }
}
